export const CLOSE_SUB_KEYBOARD_SIGNAL = 'closeSubKeyboard';
